<template>
  <div :id="id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="VideoComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

      <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="parseInt(internal_config.height)"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-VideoComponent'></options-element-bar>

      <div class="divBlock" v-show="!this.preview"></div>

      <iframe width="100%" :height="getHeight" :src="getSecret" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>



    </vue-draggable-resizable>
  </div>
</template>

<script>
import elementData from './Model';
import OptionsElementBar from '../OptionsElementBar';
import _ from 'lodash'

export default {
  name: 'VideoComponent',
  props: ['config', 'id', "preview"],
  components: { OptionsElementBar },
  data() {
    return elementData.data();
  },
  computed: {
    getSecret() {
      return `https://videomng.builderall.com/embed/${this.internal_config.secret}/`
    },
    getHeight() {
      let height =  document.querySelector('[data-device]').getAttribute('data-device') === 'desktop' ? this.internal_config.height : this.internal_config.minHeight;
      if(height == '0px') {
        height = '100%'
      }

      return height
    }
  },
  methods: {
    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';
    },
    build(config) {
      this.internal_config = _.merge(this.internal_config, config);
    },
    animation() {
      return false;
    },
    style() {
      return `width: ${this.internal_config.width};
               min-height:  ${this.internal_config.minHeight} !important;
               z-index: ${this.internal_config.zIndex};
               margin: 0 auto;
               padding-top: ${this.internal_config.paddingTop};
               padding-left: ${this.internal_config.paddingLeft};
               padding-right: ${this.internal_config.paddingRight};
               padding-bottom: ${this.internal_config.paddingBottom};
               left:  ${this.internal_config.left};
               top: ${this.internal_config.top}`;
    }
  },
  mounted() {
    this.build(this.$props.config);
    this.$root.$on('setConfigElement', (id, obj) => {
      if (+this.id === +id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    }
  }
};
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Video/Video.vue